import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@/api/baseQuery';
import { useDatasourceId } from '@/hooks';

export const GET_ZAPIER_API_KEY = 'getZapierApiKey';

export const zapierApiSlice = createApi({
  reducerPath: 'zapierApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    [GET_ZAPIER_API_KEY]: builder.query<any, any>({
      query: ({ datasourceId }) =>
        `datasources/${datasourceId}/alerts/zapier/api-key`,
    }),
  }),
});

export const { useGetZapierApiKeyQuery } = zapierApiSlice;

export const useGetZapierApiKey = () => {
  const datasourceId = useDatasourceId();

  const { data, ...rest } = useGetZapierApiKeyQuery({ datasourceId });

  return { zapierApiKey: data?.key, ...rest } as const;
};
